import { Group, Stack, Text } from "@mantine/core"
import { CountryLabel, Label, Tooltip } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { CertificateByOrganizationDto } from "~/gen/api"
import { COUNTRIES } from "~/utils/countries"

type Props = {
  certificate: CertificateByOrganizationDto
}

export function CertificateProductionSite({ certificate }: Props) {
  const { t } = useTranslation("admin")
  if (!certificate.productionSite) return null
  return (
    <Stack gap={0}>
      <Label fw={600} label={t("certificates.modal.labels.productionSite")} />
      <Group justify="space-between" wrap="nowrap">
        <Tooltip label={certificate.productionSite.address}>
          <Text fz="xs" fw={400}>
            {certificate.productionSite.name}
          </Text>
        </Tooltip>
        <CountryLabel
          inline
          countryIso3166={certificate.productionSite.countryIso3166}
          countriesMapper={COUNTRIES}
        />
      </Group>
    </Stack>
  )
}
